import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Center,
  Flex,
  Heading,
  Image,
  Link,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { EXTERNAL_LINKS } from "../../../utils/constants";
import thePlague from "../../../assets/escape_tower/the_plague_squared.jpg";
/*
import { AvailableSoon } from "../../molecules";
*/

export default function EscapeTower() {
  return (
    <>
      {/*<AvailableSoon />*/}
      <Card mb="26px" px="20px" py="10px">
        <Flex>
          <div className="relative mx-auto rounded-full overflow-hidden">
            <Image
              src={thePlague}
              title="Escape Tower horror nella Rocca degli Alberi - Montagnana (PD)"
              h={300}
              mr="20px"
            />
          </div>
          <Center>
            <Text mr="16px">
              <strong>
                Aperta dal 2 al 25 Maggio, tutti i Venerdì, Sabato e Domenica
                nella Rocca degli Alberi.
                <br />
                Prenotazioni aperte!
              </strong>
              <br />
              Età minima 16 anni.
              <br />
              Attività in collaborazione con{" "}
              <Link href={EXTERNAL_LINKS.GREAT_ESCAPE}>
                Great Escape Padova
              </Link>
            </Text>
          </Center>
          <Spacer />
          <Center>
            <Link href={EXTERNAL_LINKS.GREAT_ESCAPE_MONTAGNANA}>
              <Button>Prenota qui!</Button>
            </Link>
          </Center>
        </Flex>
      </Card>
      <Card bg={"#780404"}>
        <CardHeader>
          <Heading size="xl" color="white">
            <p className="macondo-regular">🕯️The Plague</p>
          </Heading>
          <Heading size="base" color="white" fontWeight="base">
            Escape Tower horror nella Rocca degli Alberi - Montagnana (PD)
          </Heading>
        </CardHeader>
        <CardBody>
          <Text
            className="poppins-regular"
            fontSize="18px"
            lineHeight="1.6em"
            letterSpacing="0.4px"
            color="white"
          >
            1348. A Montagnana arriva la peste.
            <br />
            Le strade si svuotano. Le porte si chiudono.
            <br />
            La Rocca viene sigillata per contenere il contagio.
            <br />
            Nessuno entra. Nessuno esce.
            <br />
            Per secoli.
            <br />
            <br />
            2025. Un gruppo di ricercatori ottiene il permesso di esplorare
            alcune stanze rimaste chiuse dal Medioevo.
            <br />
            Cercano documenti storici, testimonianze sulla peste.
            <br />
            Ma trovano molto di più.
            <br />
            <br />
            Dietro una porta murata, tra simboli cancellati e sigilli spezzati,
            scoprono un’antica quarantena.
            <br />
            E qualcosa che non sarebbe mai dovuto essere risvegliato.
            <br />
            <br />
            Non era solo peste.
            <br />
            Era qualcosa di vivo.
            <br />
            E ora lo è di nuovo.
            <br />
            <br />
            Un viaggio dentro il passato. E dentro la paura.
            <br />
            The Plague è un’escape room horror ambientata nella vera Rocca
            medievale di Montagnana.
            <br />
            Un’esperienza psicologica, immersiva e tesa.
            <br />
            Solo voi, il buio, e una verità che vuole essere dimenticata.
            <br />
            <br />
            <br />
          </Text>
          {/*<Text
            className="rock-salt-regular"
            fontSize="18px"
            lineHeight="2em"
            letterSpacing="0.4px"
            color="white"
          >
            Tally, il Mago della Rocca
          </Text>
          <Text
            className="rock-salt-regular"
            fontSize="14px"
            lineHeight="2em"
            letterSpacing="0.4px"
            color="white"
          >
            Gran Guardiano del Portale Ogangel
          </Text>*/}
        </CardBody>
      </Card>
    </>
  );
}
